import React, { useState } from 'react';
import { MapPin, AlertCircle, X } from 'lucide-react';
import './LocationPermissionModal.scss';
import { updateDevice } from './ApiHandlers';

const LocationPermissionModal = ({ isOpen, onClose, onLocationGranted, hasPreviousLocation, uid, deviceId }) => {
    const [isRequesting, setIsRequesting] = useState(false);
    const [error, setError] = useState(null);

    if (!isOpen || !uid || !deviceId) return null;

    const requestLocation = () => {
        setIsRequesting(true);
        setError(null);

        if (!navigator.geolocation) {
            setError("Tu navegador no soporta geolocalización");
            setIsRequesting(false);
            return;
        }

        console.log({ hasPreviousLocation })
        const options = {
            enableHighAccuracy: hasPreviousLocation,
            timeout: hasPreviousLocation ? 15000 : 8000,
            maximumAge: hasPreviousLocation ? 0 : 60000
        };

        let finished = false;

        const safetyTimeout = setTimeout(() => {
            if (!finished) {
                finished = true;
                setIsRequesting(false);
                setError("No se pudo obtener tu ubicación. Intenta nuevamente.");
            }
        }, options.timeout + 2000);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                if (finished) return;
                finished = true;
                clearTimeout(safetyTimeout);

                const { latitude, longitude, accuracy } = position.coords;
                onLocationGranted({ latitude, longitude, accuracy: parseInt(accuracy) });
                updateDevice(uid, deviceId, { locationStatus: 'success' })
                setIsRequesting(false);
            },
            (err) => {
                if (finished) return;
                finished = true;
                clearTimeout(safetyTimeout);

                setIsRequesting(false);

                if (err.code === 1) {
                    setError("Has bloqueado el acceso a la ubicación.");
                    updateDevice(uid, deviceId, { locationStatus: 'denied' })
                } else if (err.code === 2) {
                    setError("No se pudo determinar tu ubicación.");
                    updateDevice(uid, deviceId, { locationStatus: 'undetermined' })
                } else if (err.code === 3) {
                    updateDevice(uid, deviceId, { locationStatus: 'timeout' })
                    setError("Tiempo de espera agotado.");
                }
            },
            options
        );
    };

    return (
        <div className="location-modal-overlay" onClick={onClose}>
            <div className="location-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="location-modal-close" onClick={onClose}>
                    <X size={20} />
                </button>

                <div className="location-modal-icon">
                    <MapPin size={48} />
                </div>

                <h2 className="location-modal-title">
                    Permiso de Ubicación
                </h2>

                <p className="location-modal-description">
                    Este canal necesita acceso a tu ubicación para mostrarte información personalizada
                    de tu zona (clima, tráfico, etc.)
                </p>

                {error && (
                    <div className="location-modal-error">
                        <AlertCircle size={20} />
                        <div>{error}</div>
                    </div>
                )}

                <div className="location-modal-buttons">
                    <button
                        className="location-modal-btn-secondary"
                        onClick={onClose}
                        disabled={isRequesting}
                    >
                        Cancelar
                    </button>
                    <button
                        className="location-modal-btn-primary"
                        onClick={requestLocation}
                        disabled={isRequesting}
                    >
                        {isRequesting ? 'Solicitando...' : 'Permitir Ubicación'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LocationPermissionModal;